<template>
    <b-modal 
        :id="modalId" 
        ref="modal"
        title="Tabela" 
        size="lg" 
        scrollable
    >
        <div class="expanded-table-container" v-html="tableHtml"></div>
        
        <template #modal-footer>
            <button 
                class="btn btn-success"
                @click="exportarExcel"
                :disabled="exportando"
            >
                <i :class="exportando ? 'fa fa-spinner fa-spin' : 'fa icon-font icon-file-excel'" class="mr-1"></i>
                {{ exportando ? 'Exportando...' : 'Exportar Excel' }}
            </button>
            <button class="btn btn-secondary" @click="fechar">
                Fechar
            </button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'ModalTabelaExpandida',
    
    props: {
        modalId: {
            type: String,
            default: 'modal-table-expand'
        }
    },
    
    data() {
        return {
            tableHtml: '',
            exportando: false
        }
    },
    
    methods: {
        abrir(html) {
            this.tableHtml = html
            this.$bvModal.show(this.modalId)
        },
        
        fechar() {
            this.$bvModal.hide(this.modalId)
        },
        
        carregarSheetJS() {
            return new Promise((resolve) => {
                if (window.XLSX) {
                    resolve()
                    return
                }
                
                if (!document.querySelector('script[src="/js/dre/sheet.min.js"]')) {
                    const script = document.createElement('script')
                    script.setAttribute('src', '/js/dre/sheet.min.js')
                    script.onload = () => resolve()
                    document.head.appendChild(script)
                } else {
                    resolve()
                }
            })
        },
        
        async exportarExcel() {
            this.exportando = true
            
            try {
                await this.carregarSheetJS()
                
                const container = document.createElement('div')
                container.innerHTML = this.tableHtml
                const table = container.querySelector('table')
                
                if (!table) {
                    this.$notify.error('Nenhuma tabela encontrada para exportar')
                    return
                }
                
                const aoa = []
                const rows = table.querySelectorAll('tr')
                
                rows.forEach(tr => {
                    const row = []
                    const cells = tr.querySelectorAll('th, td')
                    cells.forEach(cell => {
                        row.push((cell.innerText || cell.textContent || '').trim())
                    })
                    if (row.length > 0) {
                        aoa.push(row)
                    }
                })
                
                if (aoa.length === 0) {
                    this.$notify.error('Tabela vazia')
                    return
                }
                
                // eslint-disable-next-line no-undef
                const ws = XLSX.utils.aoa_to_sheet(aoa)
                // eslint-disable-next-line no-undef
                const wb = XLSX.utils.book_new()
                // eslint-disable-next-line no-undef
                XLSX.utils.book_append_sheet(wb, ws, 'Dados')
                
                const nomeArquivo = `tabela-ia-${Date.now()}.xlsx`
                // eslint-disable-next-line no-undef
                XLSX.writeFile(wb, nomeArquivo)
                
                this.$notify.success('Tabela exportada com sucesso!')
            } catch (error) {
                console.error('Erro ao exportar tabela:', error)
                this.$notify.error('Erro ao exportar tabela')
            } finally {
                this.exportando = false
            }
        }
    }
}
</script>

<style scoped>
.expanded-table-container {
    overflow-x: auto;
}

.expanded-table-container :deep(table) {
    width: 100%;
    margin-bottom: 0;
}

.expanded-table-container :deep(th),
.expanded-table-container :deep(td) {
    white-space: nowrap;
    padding: 8px 12px;
}

.expanded-table-container :deep(th) {
    background: #f8f9fa;
    font-weight: 600;
    border-bottom: 2px solid #dee2e6;
}
</style>

